import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from 'react-router-dom';
import { Container, CircularProgress, Box, Typography } from '@mui/material';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SummaryPage from './pages/SummaryPage';
import CategoryTasksPage from './pages/CategoryTasksPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import AboutPage from './pages/AboutPage';
import Header from './components/Header';
import Footer from './components/Footer';
import LoginAnnouncementsGate from './components/LoginAnnouncementsGate';
import { useAuth } from './context/AuthContext';

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
        flexDirection: 'column'
      }}>
        <CircularProgress size={60} thickness={4} color="secondary" />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Verificando sesión...
        </Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user && user.isTemporaryAccount && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return (
    <>
      <LoginAnnouncementsGate />
      {children}
    </>
  );
}

function App() {
  return (
    <Router>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}>
        <Header />
        <Container component="main" maxWidth="lg" sx={{ flexGrow: 1, py: 3 }}>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route path="/about" element={<AboutPage />} />

            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <SummaryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/:status"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/category-tasks/:listId/:listName/:status"
              element={
                <ProtectedRoute>
                  <CategoryTasksPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Container>
        <Footer />
      </Box>
    </Router>
  );
}

export default App;
